<template>
    <div class="header-cart-loading" ref="rootElement">
        <h2 id="cart-fast-title" class="mt section-title">
            Sua sacola
        </h2>

        <Spinner v-if="loading" class="my"/>
        <template v-else-if="cart && cart.last_products && cart.last_products.data.length > 0">
            <ul class="px-0 py-0 mb-auto">
                <li v-for="cartProduct in cart.last_products.data"
                    class="product-list-item d-flex flex-spaced-fixed">
                    <div class="product-list-item-thumb flex-child-fixed">
                        <img :src="getProductImage(cartProduct)"
                             width="65" height="75"
                             :alt="cartProduct.product.name"
                             class="img-responsive rounded overflow-hidden"
                             v-if="getProductImage(cartProduct)">
                    </div>
                    <div>
                        <p class="product-list-item-title">
                            {{ cartProduct.product.name }}
                        </p>
                        <p class="product-list-item-subtitle">
                            <span v-if="cartProduct.product_model_name">
                                {{ cartProduct.product_model_name }}
                                <span class="hidden-sm-down">|</span>
                                <br class="hidden-sm-up"/>
                            </span>

                            {{ cartProduct.size }}
                            <br/>
                            Quantidade: {{ cartProduct.quantity }}
                        </p>
                    </div>
                    <p class="product-list-item-price">
                        {{ cartProduct.total_price | formatMoney }}
                    </p>
                    <br/>
                </li>
            </ul>

            <hr/>

            <div class="cart-footer">
                <div class="text-center">
                    <p v-if="cart.count_products > 2">+{{ cart.count_products - 2 }} produtos em sua sacola</p>
                    <template v-if="cart.total_discounts > 0">
                        <p>
                        <span>
                            Subtotal
                        </span>
                            <span v-if="cart.last_products.data.length > cart.count_products">
                            ({{ count }} itens)
                        </span>
                            <span>: {{ cart.total_products | formatMoney }}</span>
                        </p>
                        <p>Descontos: - {{ cart.total_discounts | formatMoney }}</p>
                    </template>
                    <p class="text-bold">
                    <span>
                        Total
                    </span>
                        <span v-if="cart.total_discounts === 0 && cart.last_products.data.length > cart.count_products">
                        ({{ count }} itens)
                    </span>
                        <span>: {{ Math.max(0, cart.total_products - cart.total_discounts) | formatMoney }}</span>
                        <span class="text-secondary"
                              v-if="Math.max(0, cart.total_products - cart.total_discounts) > 20 && $scope.IS_REGULAR_CUSTOMER">
                            ou 4x{{
                                ((Math.floor(((Math.max(0, cart.total_products - cart.total_discounts) / 4) * 100))) / 100) | formatMoney
                            }}
                    </span>
                    </p>
                </div>
            </div>

            <hr/>
        </template>
        <div v-else>
            <h4>Você ainda não adicionou itens à sua compra :(</h4>
        </div>

        <div class="text-center" v-if="!cart || cart.count_products > 0">
            <a href="/carrinho" target="_self" class="btn btn-lg mb">
                Ver sacola
            </a>
            <a href="/carrinho/checkout" target="_self"
               class="h5 mx-0 my-0 text-accent text-underline cursor-pointer">
                Fechar pedido
            </a>
        </div>
    </div>
</template>

<script>
    import {getProductThumbLink} from "../../../common/common";
    import {cartStore} from "../../common/store/cart-store";
    import Spinner from "@bit/chicorei.chicomponents.indicator.spinner";

    export default {
        name: "CartFastContent",

        components: {Spinner},

        props: {
            loading: Boolean,
            cart: Object,
            count: Number,
        },

        data() {
            return {
                storeState: cartStore.state
            }
        },

        computed: {
            visible() {
                return this.storeState.showFastCart;
            },
        },

        watch: {
            visible(to) {
                if (to) {
                    setTimeout(() => window.addEventListener('click', this.onWindowClick), 700);
                } else {
                    window.removeEventListener('click', this.onWindowClick);
                }
            }
        },

        methods: {
            getProductImage: function (cartProduct) {
                const productModel = (cartProduct.product.models || []).find(m => m.id === cartProduct.product_model_id);
                const fallbackImage = (productModel || {}).main_image || cartProduct.product.img_cover;

                const pixelRatio = Math.max(1, Math.min(2, window.devicePixelRatio));

                return getProductThumbLink(fallbackImage, cartProduct.product.img_thumb_png, cartProduct.fabric_id, {
                    'auto': 'format',
                    'lossless': 1,
                    'w': Math.round(65 * pixelRatio),
                    'h': Math.round(75 * pixelRatio),
                    'fit': 'crop',
                    'crop': 'entropy'
                }, cartProduct.product.fabric_id == cartProduct.fabric_id);
            },

            onWindowClick(event) {
                if (!this.$refs.rootElement.contains(event.target)) {
                    cartStore.hide();
                }
            }
        }
    }
</script>